import { Button } from "~/components/ui/button";
import { Card, CardContent } from "~/components/ui/card";
import { Link } from "@remix-run/react";
import { getRegionUrlPrefix } from "~/lib/helpers/slugHelper";
import { getFormattedCityNames, getFormattedCountryName } from "~/lib/helpers/constants";
import { OhButton } from "~/components/ui/custom-radix-components/button";
import { workspaceOptions } from "../common/constants";



const WorkspaceCard = ({ title, description, image, features, isMobile, spaceType, link, countryName, searchUrl }: any) => {
  return (
    <Card className="flex flex-col overflow-hidden shadow-custom border rounded-lg h-full">
      <img src={image} alt={title} width={500} height={300} className="w-full h-48 object-cover" />
      <CardContent className="p-5 space-y-4 flex flex-col flex-grow">
        <h3 className="text-xl font-semibold">{title}</h3>
        <p className="text-sm text-gray-600 line-clamp-3 min-h-[44px]">{description}</p>
        {isMobile ? null : <ul className="text-sm text-gray-700 space-y-1 flex-grow">
          {features.map((feature: string, idx: number) => (
            <li key={idx} className="flex items-start">
              <span className=" mr-2">✓</span> {feature}
            </li>
          ))}
        </ul>}
        <div className="mt-auto flex flex-col gap-2">
          <Link to={`${searchUrl}${spaceType ? `&workspaceType=${spaceType}` : ''}`} target="_blank">
            <OhButton className="w-full">Find {title}</OhButton>
          </Link>
          <Link to={`${getRegionUrlPrefix(countryName)}/${link}`} target="_blank">
            <Button className=" w-full" variant="outline">Learn More</Button>
          </Link>
        </div>
      </CardContent>
    </Card>
  )
};

export default function WorkspaceOptions({ isMobile, countryName, region, searchUrl }) {

  return (
    <section className="py-8 md:py-16 mx-auto">
      <div className="text-start md:text-center mb-12">
        <p className="text-sm text-gray-500 font-semibold uppercase">Office Search</p>
        <h2 className="md:px-0 text-2xl font-bold mt-2">Explore the Different Types of Office Spaces</h2>
        <p className="text-gray-700 text-md mt-2">
          Explore a range of workspace types across {getFormattedCityNames(region)} and beyond. Compare coworking, serviced, and private offices that suit your business.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3">
        {workspaceOptions.map((option, idx) => (
          <WorkspaceCard key={idx} isMobile={isMobile} {...option} countryName={countryName} searchUrl={searchUrl} />
        ))}
      </div>
    </section>
  );
}